// Single source of truth for the delivered-vehicle details routes, shared by useDealerAppRoutes and by
// consumers that link into another marketplace whose routes are not available in the current context.
export const legacyDeliveredVehicleDetailsRoute = {
	path: "/delivered-vehicles/:vehicleKey",
	url: (vehicleKey: string) => `/delivered-vehicles/${vehicleKey}`,
}

export const usedDeliveredVehicleDetailsRoute = {
	path: "/delivered-vehicles/used/:vehicleKey",
	url: (vehicleKey: string) => `/delivered-vehicles/used/${vehicleKey}`,
}
